export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-primary-500 flex items-center justify-center text-background-50 text-5xl md:text-6xl">
            <i className="ri-smartphone-line"></i>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">移动追漫</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5 max-w-lg mx-auto lg:mx-0">
              爱漫画网采用全响应式设计，手机浏览器直接访问即可畅享流畅竖屏阅读体验。无论何时何地，打开手机就能追最新的韩漫推荐、日漫大全和国漫排行榜热门漫画排行。
            </p>
            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line"></i>
                iOS 版
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-android-line"></i>
                Android 版
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}